exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 768px) {\n  .discussion-wrap {\n    padding: 0px 0px 24px 0px !important; } }\n\n.discussion-wrap {\n  margin-top: 24px;\n  padding: 0px 24px 24px 24px;\n  background-color: #f8f8f8; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component.scss
// module id = ../../../../../src/app/category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component.scss
// module chunks = main